var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 142,
    viewBox: "0 0 28 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00044 76.5C-0.499557 62.5 8.76749 52.1914 18.0006 39C25 29 28.0004 10.5 28.0005 0L27.9997 142C27.9997 120.5 22.4997 113 16.4997 105.5C10.4997 98 2.50044 90.5 1.00044 76.5Z",
    fill: "#E3F0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeArrowLeft);
export default __webpack_public_path__ + "static/media/shape_arrow_left.970c224b9efcc4958c07c09582d076f4.svg";
export { ForwardRef as ReactComponent };